import { render, staticRenderFns } from "./vpd-confirm-dialog.vue?vue&type=template&id=1e060ad3"
import script from "./vpd-confirm-dialog.vue?vue&type=script&lang=js"
export * from "./vpd-confirm-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports